import type { StateValue } from '@autobid/nuxt-pinia-store/types/Search'
import type { LocationQueryValue } from 'vue-router'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { useSearchStore } from './useSearchStore'

interface UseFormItemParams {
  key: string
  singleValue?: boolean
  dictionary?: string
}

export function useFormItem(params: UseFormItemParams & { singleValue: true }): globalThis.WritableComputedRef<LocationQueryValue, StateValue>
export function useFormItem(params: UseFormItemParams & { singleValue?: false }): globalThis.WritableComputedRef<LocationQueryValue | LocationQueryValue[], StateValue>
export function useFormItem({ key, singleValue }: UseFormItemParams): globalThis.WritableComputedRef<LocationQueryValue | LocationQueryValue[], StateValue> {
  const { debounced } = storeToRefs(useSearchStore())
  const { updateSearchValues } = useSearchStore()
  const title: string = inject('title', '')
  const route = useRoute()

  const value = computed({
    get: () => {
      const val = route.query[key]

      if (singleValue) {
        return Array.isArray(val) ? val[0] : val
      }

      return val
    },
    set: (value: StateValue) => {
      debounced.value = false
      updateSearchValues({
        key,
        value,
        title,
      })
    },
  })

  return value
}
